export type Bonus = {
  number: string
  title: string
  subtitle: string
  description: string
  promise: string
  value: string
}

export const bonuses: Bonus[] = [
  {
    number: 'Bono 01',
    title: 'Planificador Semanal de Bienestar',
    subtitle: 'Tu semana, por fin con un espacio para ti',
    description:
      'Organiza tus objetivos, hábitos y descansos en una sola vista para que cuidarte deje de ser lo último de la lista y pase a estar agendado.',
    promise: 'Deja de improvisar tu vida: planifícala desde el amor propio.',
    value: '$15.700',
  },
  {
    number: 'Bono 02',
    title: '50 Afirmaciones "Me Elijo"',
    subtitle: 'Reprograma la voz que te habla todos los días',
    description:
      'Cincuenta frases escritas para los días difíciles: para leerlas en voz alta, guardarlas en tu celular y construir, palabra a palabra, una nueva identidad.',
    promise: 'No necesitas una hora libre. Solo diez minutos y la intención de cuidarte.',
    value: '$15.700',
  },
  {
    number: 'Bono 03',
    title: 'Diario de Autoconfianza',
    subtitle: 'Para ver, por escrito, cuánto estás cambiando',
    description:
      'Una herramienta práctica para observar tus avances, reconocer tus patrones y sostener el enfoque cuando la motivación baja.',
    promise: 'Transforma tus emociones en claridad y autocompasión.',
    value: '$12.700',
  },
  {
    number: 'Bono 04',
    title: 'Reto de 30 Días para Dejar de Postergarte',
    subtitle: 'Un mes. Un paso pequeño cada día.',
    description:
      'Un proceso guiado, día a día, para recuperar tu poder personal y convertir el amor propio en un hábito y no en un buen propósito.',
    promise: 'Treinta días para volver a reconocerte frente al espejo.',
    value: '$15.700',
  },
  {
    number: 'Bono 05',
    title: 'Kit de Límites Saludables',
    subtitle: 'Aprende a decir "no" sin sentir culpa',
    description:
      'Guiones reales, frases listas para usar y ejercicios para poner límites claros, proteger tu energía y construir relaciones más equilibradas.',
    promise: 'Poner límites no te aleja de quienes amas: te devuelve a ti.',
    value: '$12.700',
  },
  {
    number: 'Bono 06',
    title: 'Meditacion guiada: Vuelve a ti',
    subtitle: 'Solo para quienes se eligen hoy',
    description:
      'Preparado con mucho cariño para acompañarte en tu transformación. Lo descubrirás apenas accedas al programa.',
    promise: 'Un último abrazo digital que no esperabas.',
    value: '$19.900',
  },
]

export const bonusesTotalValue = '$92.400'
export const productPrice = '$24.900'

/** Reemplaza esta URL por el enlace de tu pasarela de pago. */
export const checkoutUrl = 'https://shop.ingridrosales.com/products/metodo-me-elijo'
